"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentType = void 0;
var getContentType = function (ct, gt, isWeb) {
    if (isWeb === void 0) { isWeb = true; }
    switch (ct) {
        case "procedure":
            return {
                name: gt("procedure"),
                pluralName: gt("procedures"),
                icon: isWeb ? "far fa-file" : "procedure",
            };
        case "procedureversion":
            return {
                name: gt("procedure version"),
                pluralName: gt("procedure versions"),
                icon: isWeb ? "far fa-clock" : "datetime",
            };
        case "proceduregroup":
            return {
                name: gt("process"),
                pluralName: gt("processes"),
                icon: isWeb ? "far fa-copy" : "proceduregroup",
            };
        case "taskinstance":
            return {
                name: gt("task"),
                pluralName: gt("tasks"),
                icon: isWeb ? "fa fa-tasks" : "tasks-dashboard",
            };
        case "tasktemplate":
            return {
                name: gt("task"),
                pluralName: gt("tasks"),
                icon: isWeb ? "fa fa-tasks" : "tasks-dashboard",
            };
        case "team":
            return {
                name: gt("team"),
                pluralName: gt("teams"),
                icon: isWeb ? "fa fa-users" : "team",
            };
        case "user":
            return {
                name: gt("member"),
                pluralName: gt("members"),
                icon: isWeb ? "fa fa-user" : "user",
            };
        case "role":
            return {
                name: gt("role"),
                pluralName: gt("roles"),
                icon: isWeb ? "fa fa-user-tag" : "role",
            };
        case "accountprofile":
            return {
                name: gt("account"),
                pluralName: gt("accounts"),
                icon: isWeb ? "fa fa-coffee" : "",
            };
        case "policy":
            return {
                name: gt("policy"),
                pluralName: gt("policies"),
                icon: isWeb ? "fa fa-umbrella" : "policy",
            };
        case "policyversion":
            return {
                name: gt("policy version"),
                pluralName: gt("policy versions"),
                icon: isWeb ? "far fa-clock" : "datetime",
            };
        case "tag":
            return {
                name: gt("tag"),
                pluralName: gt("tags"),
                icon: isWeb ? "fa fa-tag" : "tag",
            };
        case "folder":
            return {
                name: "folder",
                pluralName: "folders",
                icon: "far fa-folder",
                iconAlt: isWeb ? "far fa-folder-open" : "",
            };
        case "knowledgebase":
            return {
                name: gt("knowledge base"),
                pluralName: gt("knowledge bases"),
                icon: isWeb ? "far fa-book-open" : "",
            };
        case "article":
            return {
                name: gt("article"),
                pluralName: gt("articles"),
                icon: isWeb ? "far fa-book" : "",
            };
        case "document":
            return {
                name: gt("document"),
                pluralName: gt("documents"),
                icon: isWeb ? "far fa-file-alt" : "",
            };
        case "lane":
            return {
                name: gt("lane"),
                pluralName: gt("lanes"),
                icon: isWeb ? "fas fa-road" : "lane",
            };
        default: {
            return { name: "", pluralName: "", icon: "" };
        }
    }
};
exports.getContentType = getContentType;
